import axios from "axios";
import config from "../config.js";

const API_BASE_URL = `${config.urlScheme}://${config.host}/managements/v1`;

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.headers.common["Authorization"] = `Bearer ${config.apiToken}`;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["X-app-id"] = "0";

// 场地列表
export async function getMeetingRooms(locationId, params) {
  return axios.get(`/meeting_rooms`, {
    params: { ...params, location_id: locationId }
  });
}
// 场地使用状况
export async function getMeetingStatus(locationId, params) {
  return axios.get(`/statistics/meeting_rooms/reservation_state_occupied_rate`, {
    params: { ...params, location_id: locationId }
  });
}

// 平均值
export async function getMeetingTotals(locationId, params) {
  return axios.get(`/statistics/meeting_rooms/sum_totals`, {
    params: { ...params, location_id: locationId }
  });
}
// 场地按天使用率
export async function getMeetingUsageRate(params, format = 'json') {
  return axios.get(`/statistics/meeting_rooms/usage_rate.${format}`, {
    params:{...params}
  });
}
// 电话厅列表
export async function getPublicZones(locationId, params) {
  return axios.get(`/areas`, {
    params: { ...params, location_id: locationId, area_type: "public_zone" }
  });
}
export async function getDesks(locationId, params) {
  return axios.get(`/locations/${locationId}/desks`, { params });
}
// 空气实时传感器数据
export async function getAirRealTime(params) {
  return axios.get(`/statistics/sensor_data/air_realtime`, { params });
}
export const getLocation = id => axios.get(`/locations/${id}`);

export const getCentrifugeToken = () => axios.post(`/realtime/token`);
// 会议室重复利用率及时间
export async function meetingRecaptureData(params) {
  return axios.get(`/statistics/meeting_rooms/recapture_data`, {
    params:{...params} 
  });
}
// 按场地统计总会议次数，参与人数，总时长
export async function getAreasByAreaId(params) {
  return axios.get(`/statistics/meeting_rooms/by_area_id`, {
    params:{...params}

  });
}
